<template>
  <v-card class="pa-4">
    <p>Would you like to copy and push catalog to all companies in corporation?</p>
    <v-checkbox
      v-model="activateAfterCopy"
      :label="$lang.labels.activateAfterCopy"
      color="primary"
      class="pb-4"
      hide-details
    />
    <v-flex xs12 pb-3 v-if="err">
      <v-alert :value="true" type="error">{{err}}</v-alert>
    </v-flex>
    <v-flex xs12 pb-3 v-if="success">
      <v-alert :value="true" type="success">{{success}}</v-alert>
    </v-flex>
    <v-layout row wrap justify-space-between>
      <v-btn flat outline @click="$emit('close')" :disabled="loading" class="mx-0">{{$lang.actions.no}}</v-btn>
      <v-btn color="primary" @click="submit()" :disabled="loading" class="mx-0">{{$lang.actions.yes}}</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    props: ['id'],
    data() {
      return {
        loading: false,
        err: '',
        success: '',
        activateAfterCopy: true,
      };
    },
    methods: {
      submit() {
        this.loading = true;
        this.$http.post(`catalog/copy/${this.id}`, { activateAfterCopy: this.activateAfterCopy })
          .then((res) => {
            if (res.body.status === 'Success') {
              this.loading = false;
              this.success = res.body.statusText;
              setTimeout(() => {
                this.success = '';
                this.$emit('close');
              },5000);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.loading = false;
            this.err = err.body.statusText || err.body.message;
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// PushToCorp.vue?179d6a13